import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const AwardSolid = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M5.771 14.695a8 8 0 0 0 4.95 2.76l.721.106-.358.635-1.864 3.297a.8.8 0 0 1-1.406-.023l-1.278-2.448-2.691.145a.8.8 0 0 1-.737-1.198l2.204-3.819zm15.3 3.256a.8.8 0 0 1-.736 1.198l-2.693-.145-1.277 2.448a.8.8 0 0 1-1.405.024l-2.224-3.933.723-.105a8 8 0 0 0 4.948-2.76l.46-.545zM19.03 9.5a7 7 0 1 1-14 0 7 7 0 0 1 14 0"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(AwardSolid) as SvgIcon;
export { ForwardRef as ReactComponent };
